import React from 'react';
import { DropdownSelect } from '@vds/selects';
import PropTypes from 'prop-types';

const CommonDropdownSelect = (props) => (
  <DropdownSelect
    label={(props && props.topLabelText) ? props.topLabelText : props.label}
    error={props.error}
    errorText={props.errorText}
    ariaLabel={props.ariaLabel}
    disabled={props.disabled}
    required={props.required}
    selectId={props.id}
    width={props.width}
    onChange={(e) => props.handleChangeEvent && props.handleChangeEvent(e)}
    inlineLabel={props.inlineLabel}
    readOnly={props.readOnly}
  >
    <option hidden value="">{props.label ? props.label : 'select'}</option>
    {props.options && props.options.map((opt) => <option className='styleview' key={opt.key} value={(props.id && props.id === 'CPCmtnList') ? opt.key : opt.value}>{opt.value}</option>)}
  </DropdownSelect>
); 
CommonDropdownSelect.defaultProps = {
  disabled: false,
  required: false,
  error: false,
  errorText: '',
  inlineLabel: false,
  readOnly: false,
};

CommonDropdownSelect.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  required:PropTypes.bool,
  id: PropTypes.string,
  width: PropTypes.string,
  handleChangeEvent: PropTypes.func,
  topLabelText: PropTypes.string,
  inlineLabel: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default CommonDropdownSelect;
